// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"145":"82eb5234","211":"6fe0ca6c","382":"6d9b0345","797":"5dde8e90"}[chunkId] + ".chunk.js";
};